import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PlumbingFixturesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PlumbingFixtures: React.FC<PlumbingFixturesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [plumbingFixtures, set_plumbingFixtures] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Plumbing Fixtures']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Plumbing Fixtures': [b.values?.['Interior']?.['Plumbing Fixtures']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Plumbing Fixtures';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(plumbingFixtures)}
                />
            ) : (
                <MoneyBox
                    id={'plumbingFixtures'}
                    allowNegative={false}
                    value={plumbingFixtures}
                    onChange={(value) => set_plumbingFixtures(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
